import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import App from './App'
import { ThemeProvider } from './components/providers/ThemeProvider'
import { setupChallengeTracking } from './services/ChallengeTracker'
import { setupAchievementSystem } from './services/AchievementManager'
import { setupNotificationSystem } from './services/NotificationService'
import { getProviderFromEnv } from './providers'
import { initializeSyncService } from './services/SyncService'
import './styles/globals.css'

// Create a query client for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Initialize backend provider (Cloudflare, mock, etc.)
getProviderFromEnv()

// Initialize sync service for offline-first cloud sync
initializeSyncService()

// Initialize game systems
setupChallengeTracking()
setupAchievementSystem()
setupNotificationSystem()

// Register service worker in production
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
}

const root = document.getElementById('root')
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Router>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </Router>
          <Toaster position="top-center" richColors closeButton />
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}
